 <!-- Main Page Start -->
 <div class="content-wrapper table-full-bx">
    <div class="page-content recruiterpanel">
  
        <div class="row">
            <div class="col-lg-12">
                <div class="ibox ">
                    <div class="ibox-body">
  
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"> <a href="javascript:void(0);" (click)="moveToPreviousScreenWithQuery()"> Search </a> </li>
                            <li class="breadcrumb-item active">Candidate Detail</li>
                        </ol>
                        <!-- Checkbox -->
                        <div class="d-flex tabBar">
                            <ul class="nav nav-pills job-list joblist1">
                                <li class="active">
                                    <a href="javascript:void(0);">Profile</a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);" (click)="goToNotes(userID)">Notes</a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);" (click)="goToActivity(userID)">Activity</a>
                                </li>
                            </ul>
                            <ul class="nav nav-pills job-list joblist2 pointer">
  
                                <li  (click)="open(sendMail,allData?.user)" title="Send Mail"> 
                                    <img src="assets/images/ic_email2.svg" class="lm"> 
                                </li>
  
                                <li class="share" (click)="openModal(forwordMail,allData)" title="Share">
                                    <img src="assets/images/ic_share.svg" class="lm"> 
                                    <!-- <div class="socialIcon">
                                       <app-share-button type="facebook" [shareUrl]="link"> </app-share-button>  
                                       <app-share-button type="linkedin" [shareUrl]="link"> </app-share-button>
                                    </div> -->
                                     
                                </li>
                                <!-- (click)="openChatView(allData)" -->
                                <li (click)="openChatJobView(jobList,allData)" title="Chat">
                                    <img src="assets/images/ic_message2.svg" class="lm">
                                </li>
                                <li (click)="addFav($event,0,allData)" title="Favourite" *ngIf="allData?.user?.isFavourite == null || allData?.user?.isFavourite == 0">
                                   <img src="assets/images/ic_star.svg" class="lm">
                               </li>
                                <li (click)="addFav($event,1,allData)" title="Favourite" *ngIf="allData?.user?.isFavourite == 1">
                                    <img src="assets/images/ic_favourite_filed.svg" class="lm">
                                </li>
                                <li (click)="onDownlaod(allData?.user?.id)" title="Download">
                                    <img src="assets/images/ic_download2.svg" class="lm">
                                </li> 
  
                                <li (click)="saveNotes($event,allData,saveNote)" title="Notes">
                                  <img src="assets/images/ic_add.svg" class="lm">
                              </li>
                                <li (click)="hideUser()" title="Hide">
                                    <img src="assets/images/ic_close2.svg" class="lm">
                                </li>
  
                            </ul>
                        </div>
                       
                        <!-- end -->
                        <div class="contentjob">
                            <!-- Basc information -->
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="whiteBox">
                                        <div class="basicbox">
                                            <div class="whiteboxinner">
                                                <div class="profileupload ">
                                                    <div class="avatar-preview">
                                                        <div id="imagePreview">
                                                            <img [src]="allData?.user?.profileImage != null ? globalUrl + allData?.user?.profileImage : 'assets/images/profile-img.jpg'" alt="profile">
                                                        </div>
                                                    </div>
                                                    <div class="pofiledetailinner">
                                                        <h5 class="name">{{allData?.user?.name || "-"}} </h5>
                                                        <p class="location"> <img src="assets/images/ic_location.svg" alt="location"> {{allData?.user?.location || "-"}}</p>
                                                        <div class="badge"><img src="assets/images/ic_badge.svg" alt="badge">
                                                            <p class="orange">{{allData?.user?.militaryJobTitle || "-"}}</p>
                                                        </div>
  
                                                    </div>
                                                </div>
  
                                                <div class="profileadd">
                                                    <a class="para6"><strong>Last activity on- </strong>: {{allData?.user?.createdAt | date}}</a>
                                                </div>
                                            </div>
                                            <p class="para4">{{allData?.user?.bio || "-"}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
  
  
                            <div class="whiteBox">
                                <div class="basicbox">
                                    <div class="basicinfo">
                                        <h4 class="heading8"> <span><strong>Basic Information</strong></span></h4>
                                        <div class="row basicdetails">
                                            <div class="col-sm-6 col-lg-3 col-md-6 ">
                                                <h6 class="heading-6">Phone</h6>
                                                <p class="para6">{{allData?.user?.countryCode + allData?.user?.phoneNumber || "-"}}</p>
  
                                            </div>
                                            <div class="col-sm-6 col-lg-3 col-md-6">
                                                <h6 class="heading-6">Email</h6>
                                                <p class="para6">{{allData?.user?.email || "-"}}</p>
  
                                            </div>
  
                                            <div class="col-sm-6 col-lg-3 col-md-6">
                                                <h6 class="heading-6">Experience</h6>
                                                <p class="para6">{{ startDate | dateDifference:endDate}}</p>
  
                                            </div>
                                            <div class="col-sm-6 col-lg-3 col-md-6">
                                                <h6 class="heading-6">Profile last visited</h6>
                                                <p class="para6">{{allData?.user?.createdAt | date}}</p>
  
                                            </div>
                                            <div class="col-sm-12 col-lg-12 col-md-12 pt-2">
                                                <h6 class="heading-6">16 personalities score link</h6>
                                                <p class="para6"> <a class="blue" href="{{allData?.user?.scoreLink}}" target="_blank">{{allData?.user?.scoreLink}}</a></p>
                                            </div>
                                        </div>
                                    </div>
  
                                </div>
                            </div>
  
  
                            <!-- Vetran exp -->
  
                            <div class="whiteBox">
                                <div class="basicbox">
  
                                    <div class="basicinfo">
                                        <h4 class="heading8"> <span><strong>Vetran Experience</strong></span></h4>
                                        <div class="row basicdetails">
                                            <div class="col-sm-12 col-lg-4 col-md-6 ">
                                                <h6 class="heading-6">Military branch served</h6>
                                                <p class="para6">{{allData?.user?.Services ||"-"}}</p>
  
                                            </div>
                                            <div class="col-sm-12 col-lg-4 col-md-6">
                                                <h6 class="heading-6">Military job title</h6>
                                                <p class="para6">{{allData?.user?.militaryJobTitle ||"-"}}</p>
  
                                            </div>
  
                                            <div class="col-sm-12 col-lg-4 col-md-6">
                                                <h6 class="heading-6">Document</h6>
                                                <p class="para6"><img src="assets/images/ic_document.svg" class="ht">{{allData?.user?.authenticityDocumentLink ||"-"}}</p>
  
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- End -->
                            <div class="whiteBox">
                                <div class="basicbox">
                                    <div class="basicinfo">
                                        <div class="basicdetails-inner">
                                            <h4 class="heading8"> <span><strong>Skills</strong></span></h4>
  
                                        </div>
                                        <div class="row basicdetails">
  
                                            <ul class="addedskills">
                                                <li *ngFor="let skill of allData?.skills; let i=index;"> {{skill.skillDetails?.name}}</li> 
                                            </ul>
  
                                        </div>
                                    </div>
  
  
                                </div>
                            </div>
  
                            <!-- start content  -->
                            <div class="whiteBox">
                                <div class="basicbox">
                                    <h4 class="heading8"><strong>Work experience</strong></h4>
  
                                    <div class="col-lg-12 education_added" *ngFor="let work of allData?.workExperiences">
                                        <div class="work-des mb-3">
                                            <p> <strong>{{ work?.companyName || "--" }}</strong> <span class="time">{{ work?.employementTypeDetails?.name || "--" }}</span>
  
                                            </p>
                                            <p class="exp para3">{{ startDate | dateDifference:endDate}}</p>
                                        </div>
                                        <ul class="timeline">
                                            <li>
                                                <span class="timeline-point-circle fill"></span>
                                                <div class="el_details">
                                                    <p> <strong>{{ work?.jobTitle || "--" }}</strong>
  
                                                    </p>
                                                    <span>{{ work?.fromDate ? (work?.fromDate | date) : "NA" }} -
                                                       {{ work?.toDate ? (work?.toDate | date) : "NA" }}</span>
                                                </div>
                                                <div class="row">
                                                    <div class="col-sm-12 col-md-12 col-lg-3">
                                                        <div class="expinner">
                                                            <h6 class="companyname">{{ work?.companyName || "--"
                                                           }} <span class="time">{{
                                                               work?.employementTypeDetails?.name || "--"
                                                             }}</span> </h6>
                                                            <p class="designation">{{ work?.jobTitle || "--" }}</p>
                                                            <p class="date">{{ work?.fromDate | date }} -
                                                               {{ work?.toDate | date }} </p>
                                                            <p class="place">{{ work?.location || "--" }}</p>
                                                        </div>
  
                                                    </div> 
                                                </div>
                                            </li>
  
                                        </ul>
                                    </div>
                                </div>
  
  
  
                            </div>
                            <!-- education -->
                            <div class="whiteBox">
                                <div class="basicbox">
                                    <h4 class="heading8"><strong>Education </strong> </h4>
  
                                    <div class="education_added">
                                        <ul class="timeline">
                                            <li *ngFor="let edu of allData?.educations; let i=index;">
                                                <span class="timeline-point-circle fill"></span>
                                                <div class="el_details">
                                                    <p> <strong> {{edu.specializationDetails?.name}} </strong>
  
                                                    </p>
                                                    <span> {{edu.universityDetails?.name}} </span>
                                                </div> 
                                                <ul class="mt-4">
                                                  <li class="pl-0"><span class="ft-wt"> GPA : </span> {{edu.gpa}} GPA </li>
  
                                                  <li class="pl-0"><span class="ft-wt"> Duration : </span> {{edu.fromDate | date}} - {{edu.toDate | date}}</li>
                                              </ul>
                                            </li> 
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <!-- end -->
                            <div class="whiteBox">
                                <div class="basicbox">
                                    <h4 class="heading8"> <strong>Volunteer</strong></h4>
                                    <div class="education_added">
                                        <ul class="timeline">
                                            <li *ngFor="let vol of allData?.volunteerExperiences; let i=index;">
                                                <span class="timeline-point-circle fill"></span>
                                                <div class="el_details">
                                                    <p> <strong>{{vol.organization}}</strong>
                                                    </p>
                                                    <p class="para3">{{vol.role}} </p>
  
                                                    <ul class="mt-4">
                                                        <li><span class="ft-wt"> Duration : </span>{{vol.fromDate | date}} - {{vol.toDate | date}}</li>
  
                                                        <li><span class="ft-wt">Description : </span>{{vol.description}}</li>
                                                    </ul>
                                                </div>
  
                                            </li> 
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="whiteBox">
                                <div class="basicbox">
                                    <h6 class="heading8">Project Undertaken</h6>
                                    <div class="education_added">
                                        <ul class="timeline">
                                            <li *ngFor="let pro of allData?.projects; let i=index;">
                                                <span class="timeline-point-circle fill"></span>
                                                <div class="el_details">
                                                    <p> <strong>{{pro.projectTitle}}</strong>
  
  
                                                    </p>
                                                    <p class="para3">{{pro.projectTitle}} </p>
  
                                                    <ul class="mt-4">
                                                        <li><span class="ft-wt"> Duration : </span>{{pro.fromDate | date}} - {{pro.toDate | date}}</li>
  
                                                        <li><span class="ft-wt">{{pro.description}}</span></li>
                                                    </ul>
                                                </div>
                                                <div class="el_details">
                                                    <p class="ft-wt">Team member</p>
                                                    <table class="detailstable">
                                                        <tr  *ngFor="let mem of pro.projectTeamMembersDetails; let i =index">
                                                            <td class="col-6">{{mem.name}}</td>
                                                            <td class="col-6">{{mem.email}}</td>
                                                        </tr>
                                                    </table>
  
                                                    <div class="form-group">
                                                        <p class="ft-wt pt-2">Media</p>
                                                        <div class="d-flex"> 
                                                            <div class="customfileupload" *ngFor="let thumb of pro.projectDocumentsDetails; let i =index">
                                                                <span><img [src]="globalUrl + thumb.fileName"/></span>
                                                            </div>
                                                        </div>
  
                                                    </div>
                                                    <ul class="pt-2">
                                                        <li><span class="ft-wt">Links</span> </li>
                                                        <li *ngFor="let link of pro.projectLinksDetails; let i =index">
                                                            <a href="{{link.link}}" class="blue-text" >{{link.link}}</a>
                                                        </li>
                                                    </ul>
                                                </div>
  
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <!-- Awards -->
                            <div class="whiteBox">
                                <div class="basicbox">
                                    <h4 class="heading8"><span><strong>Awards </strong></span></h4>
                                    <div class="education_added">
                                        <ul class="timeline">
                                            <li *ngFor="let award of allData?.awardsAndHonors; let i =index">
                                                <span class="timeline-point-circle fill"></span>
                                                <div class="el_details">
                                                    <p> <strong> {{award.name}} </strong>
  
                                                    </p>
                                                    <span> {{award.associatedWith}}</span>
                                                </div>
  
                                                <div class="el_details">
                                                    <ul>
                                                        <li><span class="ft-wt"> Duration : </span> {{award.issuesedOn | date}}  </li>
                                                        <li><span class="ft-wt"> Project description : </span> {{award.name}}</li>
                                                    </ul>
                                                </div>
                                            </li> 
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <!-- lic data -->
                            <div class="whiteBox">
                                <div class="basicbox">
                                    <p class="heading8"><strong>Licenses &amp; certifications</strong></p>
                                    <div class="education_added">
                                        <ul class="timeline">
                                            <li *ngFor="let lic of allData?.licenseAndCeritifcations; let i =index">
                                                <span class="timeline-point-circle fill"></span>
                                                <div class="el_details">
                                                    <p> <strong> {{lic.name||"-"}}</strong> </p>
  
                                                    <span> {{lic.attestedByAuthority||"-"}}</span>
                                                </div>
  
                                                <div class="el_details">
                                                    <ul>
                                                        <li><span class="ft-wt"> Issued on : </span> {{lic.issuesedOn | date}} (No expiration)</li>
                                                        <li><span class="ft-wt">Certificate Id : </span> {{lic.certificationNo||"-"}}</li>
                                                        <li><span class="ft-wt">Description : </span>{{lic.description ||"-"}}</li>
                                                    </ul>
                                                    <ul class="pt-2">
                                                        <li><span class="ft-wt">Certified URL</span>
                                                            <a href="{{lic.credentialUrl}}" class="blue-text">{{lic.credentialUrl}}</a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li> 
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <!-- languages data -->
                            <div class="whiteBox">
                                <div class="basicbox">
  
                                    <div class="basicinfo">
                                        <div class="basicdetails-inner">
                                            <p class="heading8"><strong>Languages</strong> </p>
                                        </div>
                                        <div class="row basicdetails">
  
                                            <ul class="addedskills">
                                                <li *ngFor="let lan of allData?.languages; let i =index"><strong  class="firstlCaptial">{{lan.language}}</strong> (
                                                    <span *ngIf="lan.proficiency == 'Read'">Read</span>
                                                    <span *ngIf="lan.proficiency == 'WriteRead'">Write & Read</span>
                                                    <span *ngIf="lan.proficiency == 'Speak'">Speak</span>
                                                    <span *ngIf="lan.proficiency == 'NativeBilingual'">Native or bilingual</span>)</li>
                                            </ul>
  
                                        </div>
  
                                    </div>
                                </div>
                            </div>
  
                            <div class="whiteBox">
  
                                <div class="basicbox preferences">
                                    <div class="basicinfo">
                                        <p class="heading8"> <strong>Job preferences</strong> </p>
  
                                        <div class="row basicdetails" *ngFor="let job of allData?.jobPreferences; let i =index">
                                            <div class="col-lg-4 col-md-6 sol-sm-12">
                                                <h6 class="heading-6">Preferred Industry</h6>
                                                <p class="para6"><span *ngFor="let p of job.jobPreferenceIndustriesDetails;let i=index">{{p.industryDetails?.name || "-"}}</span></p>
  
                                            </div>
                                            <div class="col-lg-4 col-md-6 sol-sm-12">
                                                <h6 class="heading-6">Preferred Job title</h6>
                                                <p class="para-16" *ngIf="job.jobPreferenceJobTitleDetails != null">
                                                    <span class="relative"
                                                        *ngFor="let proTitle of job.jobPreferenceJobTitleDetails;let j=index">
                                                        <span class="para-16 industryName" *ngIf="j<2">{{proTitle.JobTitleDetails?.name
                                                        || "-"}},</span>
                                                    </span>
                                                        
                                                        <span class="orange viewAll" (click)="openProjectDetail(projectTitleDetail)"   *ngIf="job?.jobPreferenceJobTitleDetails.length > 2">View All</span>
                                                    </p>
                                                <p class="para-16" *ngIf="job.jobPreferenceJobTitleDetails == null">-</p>
  
                                            </div>
                                            
                                          <div class="col-lg-4 col-md-6 sol-sm-12">
                                              <h6 class="heading-6">Category</h6>
                                              <p class="para-6"><span *ngFor="let category of allData?.category;let i=index;">{{category?.categoryName || "-"}}</span></p>
                                          </div>
                                          <div class="col-lg-4 col-md-6 sol-sm-12">
                                              <h6 class="heading-6">Sub-category</h6>
                                              <p class="">
                                                <span *ngFor="let subcategory of allData?.subCategory;let i=index; let isLast=last">
                                                    <span *ngIf="2>i">
                                                        {{subcategory?.subCategoryName}} {{(!isLast && 1!=i)?', ':''}}
                                                        <!-- {{(!isLast && 1!=i && subcategory?.subCategoryName!=null && subcategory?.subCategoryName!='' && subcategory?.subCategoryName!=undefined) ? (subcategory?.subCategoryName +", ") : (subcategory?.subCategoryName)}} -->
                                                    </span>
                                                    <span class="orange viewAll" (click)="openProjectDetail(subCategoryDetailPopup)"   *ngIf="allData?.subCategory.length > 1 && isLast">View All</span>
                                                </span>
                                            </p>
                                          </div>
  
                                          <div class="col-lg-4 col-md-6 sol-sm-12 ">
                                              <h6 class="heading-6">Date of availability</h6>
                                              <p class="para6">{{job.dateOfAvailability?(job.dateOfAvailability | date):'-'}}</p>
  
                                          </div>
                                          <div class="col-lg-4 col-md-6 sol-sm-12 ">
                                              <h6 class="heading-6">Desired salary</h6>
                                              <p class="para6">${{job.desiredSalary}}/{{job.desiredSalaryType}}</p>
  
                                          </div>
  
                                          <!-- <div class="col-lg-4 col-md-6 sol-sm-12 ">
                                              <h6 class="heading-6">Military branch served</h6>
                                              <p class="para6">{{allData?.user?.Services || "-"}}</p>
                                          </div> -->
                                          <div class="col-lg-4 col-md-6 sol-sm-12 ">
                                              <h6 class="heading-6">Military job title</h6>
                                              <p class="paar6">{{allData?.user?.militaryJobTitle || "-"}}</p>
  
                                          </div>
                                            <div class="col-lg-4 col-md-6 sol-sm-12 " *ngIf="!allData?.userTourOfDuties">
                                                <h6 class="heading-6">Country served In</h6>
                                                <p class="para6">
                                                   <span *ngFor="let c of allData?.userTourOfDuties
                                                   ;let i=index">{{c?.location || "-"}}</span> 
                                               </p>
  
                                            </div>
  
                                            <div class="col-lg-4 col-md-6 sol-sm-12 " *ngIf="!allData?.userTourOfDuties">
                                                <h6 class="heading-6">Years served from</h6>
                                                <p class="para6">
                                                   <span *ngFor="let y of allData?.userTourOfDuties
                                                   ;let i=index">{{y?.fromDate | date}} to {{y?.toDate | date}}</span> </p>
  
                                            </div>
  
  
                                            <div class="col-lg-4 col-md-6 sol-sm-12 ">
                                                <h6 class="heading-6">Preferred job Location</h6>
                                                <p class="para6"><span *ngFor="let loc of allData?.jobPreferences; let i=index;"><span *ngFor="let jloc of loc?.jobPreferenceLocationDetails; let i=index;">{{jloc?.location || "-"}}</span></span>
                                                   </p>
  
                                            </div>
  
                                            <div class="col-lg-4 col-md-6 sol-sm-12 ">
                                                <h6 class="heading-6">Employment type</h6>
                                                <p class="">
                                                    <!-- {{job.employementTypeDetails?.name ||"-"}} -->
                                                    <span *ngFor="let emp of job?.employmentTypeMultipleDetail;let i=index; let isLast=last">
                                                        <span>
                                                            {{emp?.name}}{{(!isLast && 1!=i)?', ':''}}
                                                        </span>
                                                        </span>
                                                </p>
  
                                            </div>
  
                                            <div class="col-lg-4 col-md-6 sol-sm-12 ">
                                              <h6 class="heading-6">Preferred work type</h6>
                                              <p class="para6">{{workShow(job?.workPlace)}}</p>
  
                                          </div>
  
                                            <div class="col-lg-4 col-md-6 sol-sm-12 ">
                                                <h6 class="heading-6">Travel requirements</h6>
                                                <p class="para6"><span *ngFor="let t of allData?.jobPreferences; let i=index;">
                                                   <span *ngFor="let trav of t?.jobPreferenceTravelRequirementsDetails; let i=index;">{{trav?.travelRequirementsDetails?.name || "-"}}</span></span></p>
  
                                            </div>
  
                                            <div class="col-lg-4 col-md-6 sol-sm-12 ">
                                                <h6 class="heading-6">Security clearance</h6>
                                                <p class="para6"><span *ngFor="let s of job?.jobPreferenceSecurityClearanceDetails; let i=index;">{{s?.securityClearanceDetails?.name || "-"}}</span></p>
  
                                            </div>
  
  
                                            <div class="col-lg-4 col-md-6 sol-sm-12 ">
                                                <h6 class="heading-6">Willing to relocate</h6>
                                                <p class="para6">{{job?.willingToRelocate == 1 ? "Yes" :"No"}}</p>
  
                                            </div>
                                            <div class="col-lg-4 col-md-6 sol-sm-12 ">
                                                <h6 class="heading-6">Military Branch Served</h6>
                                                <p class="para6">{{job?.serviceDetails?.name || "-"}}</p>
  
                                            </div>
  
                                            <div class="col-lg-4 col-md-6 sol-sm-12 ">
                                                <h6 class="heading-6">Work Authorization</h6>
                                                <p class="para6">
                                                    <span *ngIf="job?.workAuthorization == 0">No</span>
                                                    <span *ngIf="job?.workAuthorization == 1">Green card</span>
                                                    <span *ngIf="job?.workAuthorization == 2">EAD</span>
                                                    <span *ngIf="job?.workAuthorization == 3">H1B Visa</span>
                                                    <span *ngIf="job?.workAuthorization == 4">Citizen</span> 
                                                </p>
  
                                            </div>
  
                                            <div class="col-lg-4 col-md-6 sol-sm-12 ">
                                                <h6 class="heading-6">Service disabled?</h6>
                                                <p class="para6">{{job?.serviceDisabled == 1 ? "Yes" :"No"}}</p>
  
                                            </div>
  
                                            <div class="col-lg-4 col-md-6 sol-sm-12">
                                                <h6 class="heading-6">Are you vaccinated?</h6>
                                                <p class="para6">{{job?.covidVaccinated == 1 ? "Yes" :"No"}}</p>
  
                                            </div>
  
  
  
                                        </div>
                                    </div>
  
                                </div>
  
                            </div>
  
                        </div>
                    </div>
  
                </div>
            </div>
  
  
        </div>
  
    </div>
  </div>
  
  <!-- End -->
<!-- project detail -->

<ng-template #projectTitleDetail>
    <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" (click)="closeModal()">&times;</button> 
        <p class="para-16">
            <span *ngFor="let jobName of allData?.jobPreferences;let i=index;"  class="industryName">
                <span *ngFor="let proTitle of jobName.jobPreferenceJobTitleDetails;let j=index; let isLast=last"> {{proTitle.JobTitleDetails?.name}} {{ isLast ? "" : ", " }}</span>
            </span>
        </p>
    </div>
</ng-template>
<!-- job list -->

<ng-template #subCategoryDetailPopup>
    <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" (click)="closeModal()">&times;</button> 
        <p class="para-16">
            <span *ngFor="let subcategory of allData?.subCategory;let i=index; let isLast=last">
                {{subcategory?.subCategoryName || "-"}}{{isLast ? "" : ", "}}
            </span>
        </p>
    </div>
</ng-template>

<ng-template #jobList>
    <div class="modal-body addModal text-left chatTable"> 
        <h4 class="pageTitle">Job List</h4>
        <div class="table-wrapper table-scroll table-responsive mt-3">
            <table id="example" class="table table-hover m-0 table-bordered" style="width:100%;">

                <thead>
                    <tr>
                        <th>Job Id </th>
                        <th>Job title</th>
                        <th>Post Date</th>
                        <th>User </th>
                        <th>Status</th>
                    </tr>
                </thead>

                <tbody>
                    <!-- 1 -->
                    <tr
                        *ngFor="let jobData of allJobsList | paginate: { id:'paginationList', itemsPerPage: paginationList.limit, currentPage: currentPagejobList ,totalItems: paginationList.totalItems};let i=index">
                        <td><a href="javascript:void(0);" class="jobid"> <div class="checkBox_set"><label class="checkbox leftlabel">
                            <input type="checkbox" (change)="userSelect($event,i)"
                                [(ngModel)]="jobData.IsSelete"><i class="input-helper"></i>
                        </label>
                    </div> {{jobData.newId}}</a></td>
                        <td><a href="javascript:void(0);" >{{jobData.jobTitle}}</a></td>
                        <td><a href="javascript:void(0);" >{{jobData.createdAt | date:
                                "d/M/YYYY"}}</a></td>
                        <td><a href="javascript:void(0);" >
                                <span *ngIf="jobData.userType=='SUPER_RECRUITER'"
                                    style="display: inline;">{{jobData?.recruiterName}}</span>
                                <span *ngIf="jobData.userType=='SUB_RECRUITER'"
                                    style="display: inline;">{{jobData?.subRecruiterName}}</span>
                            </a></td> 
                        <td>
                            <a href="javascriot:void(0);">
                                <span class="green"
                                        *ngIf="jobData?.isBlocked == 0 && jobData?.isConfirm == 1">Open</span>
                                <span class="red"
                                        *ngIf="jobData?.isBlocked == 1  && jobData?.isConfirm == 1">Closed</span>
                                <span class="red" *ngIf="jobData?.isConfirm == 0">Draft</span>
                            </a>
                        </td> 
                    </tr>
                </tbody>
            </table>

            <div class="noDataFound" *ngIf="allJobsList == 0">
                <h2>No records found</h2>
            </div>
        </div> 
        <div class="col-sm-12 p-0" *ngIf="totalJobCount > 0">
            <ul class="pagination ">
                <pagination-controls id="paginationList" (pageChange)="pageChangedList($event)"
                    previousText="&#60;" nextText="Next" firstText="&#62;"
                    lastText="Last"></pagination-controls>
            </ul>
        </div>
    </div>
</ng-template>
  
  <ng-template #sendMail>
      <div class="modal-body addModal text-left"> 
          <form class="mailTemplate" [formGroup]="mailSendForm" (ngSubmit)="onSendMail()">
              <h4 class="pageTitle upper">Email Candidate</h4>
            <div class="form-group">
              <div class="d-flex">
                  <label>To:</label>
                  <input type="text" class="form-control" placeholder="Enter" formControlName="toEmail">
                  <div class="text-danger" *ngIf="mailSendForm.controls['toEmail'].hasError('required') && showError">
                      *Please Enter To address.
                  </div>
                  <div class="text-danger" *ngIf="mailSendForm.controls['toEmail'].hasError('pattern') && showError">
                    *Please enter valid email.
                  </div> 
              </div> 
            </div>
            <div class="form-group">
              <div class="d-flex">
                  <label>Template:</label>
                  <select class="form-control" (change)="onTemplateTypeSelect($event)">
                      <option selected disabled>Please select</option>
                      <option value="-1">None</option>
                      <option *ngFor="let tem of templateData; let i=index" [value]="i">{{tem.actionType}}</option> 
                  </select> 
              </div> 
            </div>
            <div class="form-group">
              <div class="d-flex">
                  <label>Subject:</label>
                  <input type="text" class="form-control" placeholder="Enter" formControlName="subject">
                  <div class="text-danger" *ngIf="mailSendForm.controls['subject'].hasError('required') && showError">
                      *Please Enter subject.
                  </div>
              </div> 
            </div>
            <div class="form-group">
              <textarea class="form-control pdding-10" placeholder="Please write here" maxlength="2000" formControlName="message"></textarea>
              <div class="text-danger" *ngIf="mailSendForm.controls['message'].hasError('required') && showError">
                  *Please Enter Template.
              </div>
              <div class="text-danger" *ngIf="mailSendForm.controls['message'].invalid && showError">
                  *Please add follow placeholder mentioned below to send mail.
              </div>
            </div>
            <div class="text-right">
            <div class="form-group text-right">
              <a href="javascript:void(0);" class="planbtn greyBtn" (click)="modalRef?.hide()">Cancel</a> 
              <input type="submit" value="Send"  class="planbtn fill">
            </div>
            
          </div>
              
            <div class="instruction">
              <h5><img src="../../../../assets/images/info-circle.svg" alt="info-circle"> The following place holders are allowed:</h5>
              <ul>
                  <li>
                      •  &#10100;&#10100;USERNAME&#10101;&#10101; - Username for whom the mail will be sent 
                  </li>
                  <li>
                      • &#10100;&#10100;USERFULLNAME&#10101;&#10101; - Sender’s full name 
                  </li>
                  <li>
                      • &#10100;&#10100;MYEMAIL&#10101;&#10101; - Sender’s email address 
                  </li>
                  <li>
                      • &#10100;&#10100;EMAIL&#10101;&#10101; - Recipient’s email address 
                  </li>
                  <li>
                      • &#10100;&#10100;ORGANIZATIONNAME&#10101;&#10101; - Organization Name for which the Action is performed 
                  </li>
              </ul>
            </div> 
          </form>
    </div>
    </ng-template> 
  
  <ng-template #forwordMail>
      <div class="modal-body addModal text-left"> 
          <form class="mailTemplate forWord" [formGroup]="mailForwardForm" (ngSubmit)="onForwardMail()">
              <h4 class="pageTitle upper">Forward Candidate ({{userName}})</h4>
            <div class="form-group">
              <div class="d-flex">
                  <label>To:</label>
                  <input type="text" class="form-control" placeholder="Enter" formControlName="toEmail">
                  <div class="text-danger" *ngIf="mailForwardForm.controls['toEmail'].hasError('required') && showError">
                      *Please Enter To address.
                  </div>
                  <div class="text-danger" *ngIf="mailForwardForm.controls['toEmail'].hasError('pattern') && showError">
                      *Please Enter valid email address.
                  </div>
              </div> 
            </div>
            <div class="form-group">
              <div class="d-flex">
                  <label>Job Title:</label>
                  <input type="text" class="form-control" placeholder="Enter" formControlName="jobTitle">
                  <div class="text-danger" *ngIf="mailForwardForm.controls['jobTitle'].hasError('required') && showError">
                      *Please Enter job title.
                  </div>
              </div> 
            </div>
            <div class="form-group">
              <div class="d-flex">
                  <label>Subject:</label>
                  <input type="text" class="form-control" placeholder="Enter" formControlName="subject">
                  <div class="text-danger" *ngIf="mailForwardForm.controls['subject'].hasError('required') && showError">
                      *Please Enter subject.
                  </div> 
              </div> 
            </div>
            <div class="form-group">
              <div class="d-flex">
                  <label>Candidates:</label>
                  <input type="text" class="form-control" placeholder="Enter" formControlName="candidate">
                  <div class="text-danger" *ngIf="mailForwardForm.controls['candidate'].hasError('required') && showError">
                      *Please Enter candidate name.
                  </div> 
              </div> 
            </div>
            <div class="form-group">
              <textarea class="form-control pdding-10" placeholder="Please write here" maxlength="2000" formControlName="message"></textarea>
              <div class="text-danger" *ngIf="mailForwardForm.controls['message'].hasError('required') && showError">
                  *Please Enter message.
              </div>
            </div>
            <div class="text-right">
            <div class="form-group text-right buttonWrap">
              <a href="javascript:void(0);" class="planbtn greyBtn" (click)="modalRef?.hide()">Cancel</a> 
              <input type="submit" value="Forward Candidate"  class="planbtn fill largeBtn">
            </div>
            
          </div> 
          </form>
    </div>
    </ng-template> 
    
  
  <ng-template #saveNote>
      <div class="modal-body addModal text-left"> 
          <form [formGroup]="saveNoteForm" (ngSubmit)="onSaveNote()">
            <h4 class="uppercasetext">Create note for {{allData?.user?.name || "-"}}</h4> 
            <div class="form-group">
              <label> Status : </label>
              <select class="form-control" formControlName="status">
                  <option value="0"> Pending</option> 
                  <option value="1"> Shortlist</option> 
                  <option value="2"> Rejected</option> 
                  <option value="3"> On Hold</option> 
                  <option value="4">BV not cleared</option> 
                  <option value="5">Hired</option> 
              </select>
           </div>
            <div class="form-group">
              <label>Note</label>
              <textarea class="form-control" placeholder="Enter Note here..." formControlName="note" maxlength="2000"></textarea>
              <p class="para5 text-left m-0">{{saveNoteForm?.value?.note?.length}}/2000</p>
            </div> 
            <div class="d-flex">
  
              <div class="form-group"> 
                <a href="javascript:void(0);" class="planbtn greyBtn" (click)="close()">Cancel</a>
                </div> 
            <div class="form-group"> 
              <input type="submit" value="Save"  class="planbtn fill">
            </div>
            
          </div>
          </form>
    </div>
    </ng-template>